



































import { defineComponent, toRefs } from '@vue/composition-api';
import accountAssociationHandler from '@/renderer/views/desktop/ManageConsole/AccountAssociation/composition/accountAssociationHandler';
export default defineComponent({
  props: {
    type: {
      type: String,
      default: '',
    },
    weworkType: {
      type: String,
      default: '',
    },
    ssoType: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'base',
    },
  },
  setup(props, context) {
    const { type, weworkType, ssoType } = toRefs(props);
    const { methods: associationMethods } = accountAssociationHandler();
    const methods = {
      onConfirm() {
        if (weworkType.value === 'delegate') return;
        context.emit('confirm');
      },
    };
    return {
      ...methods,
      associationMethods,
    };
  },
});
